import React from 'react';
import './App.css';
import 'tachyons';
import bestfriends from './Styling/best-friends-cover.jpg';
import collision from './Styling/collision-cover.jpg';

const Ebooks =() => {
  return (
      <div className="Ebook-Content pb4">
    <div className="ebook-backgroundImage">
     <div id="Ebooks" className="Content parallax">
      <h1 className="ebook-heading2 f1">My eBooks</h1>
      <div className="dt mw9 center pv5-m">
         <h2 className="dt mw9 center pv5-m"> All of the ebooks below are available in pdf format. <br></br>
          Method of purchase is through Paypal.</h2>
        <div className="ebook-contents">


          <article className="dtc v-mid pt0 pb0">
          <h1>Best friends</h1>
            <img src={bestfriends} alt="Best Friends Cover" className="h5 w5 dib pa2" />

                
                    <p className="lh-copy mw8 f4">
                        A small group of friends, try to navigate through the turmoil of school, and matrix farewell.
                        Alex Langton also has to deal with her crush on her next door neighbour, Adam Reed.

                        Her best friends, Sonette and Lionel also have to deal with grown-up problems.

                        Not to mention University. Will everyone still be together after their final year of high school?
                        
                        <br ></br>
                        <a href="https://payhip.com/b/w8EL" className="payhip-buy-button" data-theme="blue" data-product="w8EL">Buy Now</a>

                    </p>
                
         
            <br></br>     
            <br></br>    
            <br></br>
            <br></br>     
            <br></br>


            <h1>Collision</h1>
            <img src={collision} alt="Collision Cover" className="h5 w5 dib pa2" />

                
                <p className="lh-copy mw8 f4">
                Abbigail is a secret writer, and her social life seriously sucks. 
                She stood witness to the previous year's car crash, as she is now racing against time to finish her latest book and to make sure that a stalker doesn't find out her secret. 
                Matt, who's best friend was in the crash, decides to finally talk to Abbigail about the crash, as they are both trying to figure out this mystery. 
                Will Abbigail's book be ever finished? Will Tom's death finally have the closure it deserves?
                <br></br>
                <a href="https://payhip.com/b/4cVT" className="payhip-buy-button" data-theme="blue" data-product="4cVT">Buy Now</a>
                </p>

                
           </article>
           </div>
           
      </div>
    </div>
    
    </div>
    </div>
  );
}

export default Ebooks;